import { useEffect } from 'react';

export function RedirectStripeCheckout() {
  useEffect(() => {
    const checkoutUrl = new URLSearchParams(window.location.search).get(
      'checkout_url',
    );
    if (checkoutUrl) {
      window.location.replace(checkoutUrl);
    }
  }, []);
  return null;
}
